(() => {
  const carouselSelector = '[data-bywaqa-ingredient-carousel]';

  const initCarousel = (section) => {
    if (!section || section.dataset.bywaqaIngredientCarouselInitialized === 'true') return;

    const track = section.querySelector('[data-bywaqa-ingredient-carousel-track]');
    const cards = Array.from(section.querySelectorAll('[data-bywaqa-ingredient-carousel-card]'));
    const previousButton = section.querySelector('[data-bywaqa-ingredient-carousel-prev]');
    const nextButton = section.querySelector('[data-bywaqa-ingredient-carousel-next]');
    const dots = Array.from(section.querySelectorAll('[data-bywaqa-ingredient-carousel-dot]'));

    if (!track || cards.length === 0 || !previousButton || !nextButton) return;

    section.dataset.bywaqaIngredientCarouselInitialized = 'true';

    const getActiveIndex = () => {
      const trackCenter = track.scrollLeft + track.clientWidth / 2;

      return cards.reduce(
        (closest, card, index) => {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const distance = Math.abs(cardCenter - trackCenter);

          return distance < closest.distance ? { index, distance } : closest;
        },
        { index: 0, distance: Infinity }
      ).index;
    };

    const updateControls = () => {
      const activeIndex = getActiveIndex();

      dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
      });

      previousButton.disabled = activeIndex === 0;
      nextButton.disabled = activeIndex === cards.length - 1;
    };

    const scrollToIndex = (index) => {
      const clampedIndex = Math.max(0, Math.min(cards.length - 1, index));
      const target = cards[clampedIndex];
      const left = target.offsetLeft - (track.clientWidth - target.clientWidth) / 2;

      track.scrollTo({ left, behavior: 'smooth' });
    };

    let updateFrame;
    const requestControlUpdate = () => {
      if (updateFrame) cancelAnimationFrame(updateFrame);
      updateFrame = requestAnimationFrame(updateControls);
    };

    previousButton.addEventListener('click', () => scrollToIndex(getActiveIndex() - 1));
    nextButton.addEventListener('click', () => scrollToIndex(getActiveIndex() + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => scrollToIndex(index)));
    track.addEventListener('scroll', requestControlUpdate, { passive: true });
    window.addEventListener('resize', requestControlUpdate, { passive: true });

    requestControlUpdate();
  };

  const initAll = (root = document) => {
    if (root.matches?.(carouselSelector)) initCarousel(root);
    root.querySelectorAll?.(carouselSelector).forEach(initCarousel);
  };

  if (window.BywaqaIngredientCarousel) {
    window.BywaqaIngredientCarousel.initAll(document);
    return;
  }

  window.BywaqaIngredientCarousel = { initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
